/** The portal's icons: 20px grid, 1.6 stroke, `currentColor`. */
type IconProps = { className?: string }

const svg = (path: JSX.Element) =>
  function Icon({ className = 'h-[18px] w-[18px]' }: IconProps) {
    return (
      <svg className={className} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {path}
      </svg>
    )
  }

export const OverviewIcon = svg(<><rect x="3" y="3" width="6" height="7" rx="1.5" /><rect x="11" y="3" width="6" height="4" rx="1.5" /><rect x="11" y="10" width="6" height="7" rx="1.5" /><rect x="3" y="13" width="6" height="4" rx="1.5" /></>)
export const UsersIcon = svg(<><circle cx="7.5" cy="7" r="3" /><path d="M2.5 16.5c.4-2.8 2.4-4.5 5-4.5s4.6 1.7 5 4.5" /><circle cx="14.5" cy="7.5" r="2.3" /><path d="M14 12c2 .1 3.3 1.5 3.6 3.5" /></>)
export const SearchIcon = svg(<><circle cx="9" cy="9" r="5.2" /><path d="m13 13 3.5 3.5" /></>)
export const ChevronIcon = svg(<path d="m7.5 4.5 5.5 5.5-5.5 5.5" />)
export const BackIcon = svg(<path d="M12.5 4.5 7 10l5.5 5.5" />)
export const ExternalIcon = svg(<><path d="M11 4h5v5M16 4l-7 7" /><path d="M14 11.5V15a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 4 15V8a1.5 1.5 0 0 1 1.5-1.5H9" /></>)
export const CheckIcon = svg(<path d="m4.5 10.5 3.5 3.5 7.5-8" />)
export const SunIcon = svg(<><circle cx="10" cy="10" r="3.3" /><path d="M10 2.5v1.8M10 15.7v1.8M2.5 10h1.8M15.7 10h1.8M4.7 4.7 6 6M14 14l1.3 1.3M4.7 15.3 6 14M14 6l1.3-1.3" /></>)
export const MoonIcon = svg(<path d="M16.5 11.8A6.8 6.8 0 0 1 8.2 3.5a6.8 6.8 0 1 0 8.3 8.3Z" />)
export const AccountIcon = svg(<><circle cx="10" cy="7.5" r="3.2" /><path d="M3.8 16.8c.7-3 3.1-4.8 6.2-4.8s5.5 1.8 6.2 4.8" /></>)

export const TicketIcon = svg(<><path d="M3 6.5A1.5 1.5 0 0 1 4.5 5h11A1.5 1.5 0 0 1 17 6.5V8a2 2 0 0 0 0 4v1.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5V12a2 2 0 0 0 0-4V6.5Z" /><path d="M12 5.5v1.5M12 9.25v1.5M12 13v1.5" /></>)
export const CoinsIcon = svg(<><ellipse cx="8" cy="6" rx="4.5" ry="2" /><path d="M3.5 6v3c0 1.1 2 2 4.5 2s4.5-.9 4.5-2V6" /><path d="M3.5 9v3c0 1.1 2 2 4.5 2 .6 0 1.2-.05 1.7-.15" /><ellipse cx="13" cy="12" rx="3.5" ry="1.6" /><path d="M9.5 12v2.4c0 .9 1.6 1.6 3.5 1.6s3.5-.7 3.5-1.6V12" /></>)
export const BankIcon = svg(<><path d="M3 8 10 4l7 4" /><path d="M4.5 8.5v6M8 8.5v6M12 8.5v6M15.5 8.5v6" /><path d="M3 16.5h14" /></>)
export const CopyIcon = svg(<><rect x="7" y="7" width="9.5" height="9.5" rx="1.8" /><path d="M13 7V5a1.5 1.5 0 0 0-1.5-1.5h-6A1.5 1.5 0 0 0 4 5v6.5A1.5 1.5 0 0 0 5.5 13H7" /></>)
export const LinkIcon = svg(<><path d="M8.5 11.5a3 3 0 0 0 4.2 0l2.6-2.6a3 3 0 0 0-4.2-4.2l-.9.9" /><path d="M11.5 8.5a3 3 0 0 0-4.2 0l-2.6 2.6a3 3 0 0 0 4.2 4.2l.9-.9" /></>)
export const PlusIcon = svg(<path d="M10 4.5v11M4.5 10h11" />)
export const SparkIcon = svg(<path d="M10 3v3M10 14v3M3 10h3M14 10h3M5.2 5.2l2 2M12.8 12.8l2 2M5.2 14.8l2-2M12.8 7.2l2-2" />)
export const LogoutIcon = svg(<><path d="M8 4H5.5A1.5 1.5 0 0 0 4 5.5v9A1.5 1.5 0 0 0 5.5 16H8" /><path d="M12 6.5 15.5 10 12 13.5M15.5 10H8" /></>)
export const LockIcon = svg(<><rect x="4.5" y="9" width="11" height="8" rx="1.8" /><path d="M7 9V6.5a3 3 0 0 1 6 0V9" /></>)
export const MenuIcon = svg(<path d="M3.5 6h13M3.5 10h13M3.5 14h13" />)

export function LogoMark({ className = 'h-8 w-8' }: IconProps) {
  return (
    <span className={`relative grid shrink-0 place-items-center rounded-[9px] bg-ink text-oncolor ${className}`}>
      <svg className="h-4 w-4" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M3.25 3.5 6.75 7l-3.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
        <path d="M7.25 3.5 10.75 7l-3.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {/* The blue dot is what tells the partner door from the job seeker and admin apps. */}
      <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border-2 border-surface bg-info" aria-hidden="true" />
    </span>
  )
}

export function Avatar({ name, size = 'md' }: { name: string | null | undefined; size?: 'sm' | 'md' | 'lg' }) {
  const letters = (name ?? '?')
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
  const box = { sm: 'h-7 w-7 text-[11px]', md: 'h-9 w-9 text-[12.5px]', lg: 'h-12 w-12 text-[15px]' }[size]
  return <span className={`grid shrink-0 place-items-center rounded-full bg-accent-soft font-semibold text-ink-soft ${box}`}>{letters || '?'}</span>
}
